import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import CommentsList from '../components/CommentsList'
import { commentActionCreators } from '../modules/feedItems'

export default connect(
  createStructuredSelector<ApplicationState, ICurrentUserState>({
    user: selectCurrentUser(),
  }),
  commentActionCreators,
)(CommentsList)
